import { useEffect, useState } from 'react';
import api from '@/lib/api';

interface PackingItem {
  id: string;
  orderNumber: string;
  status: string;
  weight: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  trackingCode: string | null;
  createdAt: string;
}

const packingStatusLabels: Record<string, { label: string; color: string }> = {
  PENDING: { label: 'Pendente', color: 'bg-gray-100 text-gray-700' },
  IN_PROGRESS: { label: 'Em Progresso', color: 'bg-yellow-100 text-yellow-700' },
  COMPLETED: { label: 'Embalado', color: 'bg-green-100 text-green-700' },
};

export default function PackingPage() {
  const [items, setItems] = useState<PackingItem[]>([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    api.get('/packing').then((r) => {
      setItems(r.data.data || r.data);
      setLoadingData(false);
    });
  }, []);

  return loadingData ? (
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-dark-100 overflow-hidden">
          <table className="w-full">
            <thead className="bg-dark-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Pedido</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Status</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-dark-500 uppercase">Peso (kg)</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-dark-500 uppercase">Dimensões (cm)</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Rastreio</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Data</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-dark-100">
              {items.map((item, index) => (
                <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-dark-50/50'}>
                  <td className="px-6 py-4 text-sm font-medium text-primary-600">{item.orderNumber}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${packingStatusLabels[item.status]?.color || 'bg-gray-100 text-gray-700'}`}>
                      {packingStatusLabels[item.status]?.label || item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-dark-600 text-right">
                    {item.weight ? `${item.weight.toFixed(2)}` : '-'}
                  </td>
                  <td className="px-6 py-4 text-sm text-dark-600 text-right">
                    {item.length && item.width && item.height
                      ? `${item.length} x ${item.width} x ${item.height}`
                      : '-'}
                  </td>
                  <td className="px-6 py-4 text-sm text-dark-600">{item.trackingCode || '-'}</td>
                  <td className="px-6 py-4 text-sm text-dark-500">
                    {new Date(item.createdAt).toLocaleDateString('pt-BR')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && (
            <div className="text-center py-12 text-dark-500">Nenhum item para embalar</div>
          )}
        </div>
  );
}
